import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link, useLocation  } from 'react-router-dom';



const Header = () => {
	const navigate = useNavigate();

	const array = [ 
		{
			path: 'home',
 			actif: '',  
		},
		{
			path: 'about',
 			actif: '',  
		},
		{
			path: 'import-export',
 			actif: '', 
		},
		{
			path: 'expertise',
 			actif: '',  
		},
		{
			path: 'contact',
 			actif: '' 
		},
	]

	const [ active, setActive ] = useState( array );
	
	const handleClickGoto = ( goTo ) => {
		const path = '/' + goTo;
		navigate( path );
	}

	// get the profile data
	useEffect( () => {
		
		const path = window.location.pathname.replace( '/', '' );
		console.log( 'path', path );
console.log( 'active', active );
		const newActiveArr = active.map( e =>  e.path != path ? ({ path : e.path, actif : '' }) : ({ path : e.path, actif : 'active' } ) ); // 
		
console.log( 'newActiveArr', newActiveArr );

		setActive( newActiveArr );	

	}, [] );
	
	return (
		<>
			<header className="stick" style={{marginTop:0}}>
				<div className="header">
					<div className="container">
					<div className="row">
						<div className="col-xl-3 col-lg-3 col-md-3 col-sm-3 col logo_section">
							<div className="full">
								<div className="center-desk">
								<div className="logo">
									<Link to="/home">
										<img src='./img/logo.png' style={{width:'78px'}} alt="#" />
									</Link>
								</div>
								</div>
							</div>
						</div>
						<div className="col-xl-9 col-lg-9 col-md-9 col-sm-9">
							<nav className="navigation navbar navbar-expand-md navbar-dark ">
								<button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample04" aria-controls="navbarsExample04" aria-expanded="false" aria-label="Toggle navigation">
								<span className="navbar-toggler-icon"></span>
								</button>
								<div className="collapse navbar-collapse" id="navbarsExample04">
									<ul className="navbar-nav mr-auto">
									  <li className={ "nav-item " + active[0].actif }>
										 <a style={{ cursor: 'pointer' }} className="nav-link" onClick={ e => handleClickGoto( 'home' ) }>
											Home
										 </a>
									  </li>
									 <li className={ "nav-item " + active[1].actif }>
										<a style={{ cursor: 'pointer' }} className="nav-link" onClick={ e => handleClickGoto( 'about' ) }>
											About
										</a>
									  </li>
									  <li className={ "nav-item " + active[2].actif }>
										<a style={{ cursor: 'pointer' }} className="nav-link" onClick={ e => handleClickGoto( 'import-export' ) }>
											Import - Export
										</a>
									  </li>
									  <li className={ "nav-item " + active[3].actif }>
										 <a style={{ cursor: 'pointer' }} className="nav-link" onClick={ e => handleClickGoto( 'expertise' ) }>	Expertise
										 </a>
									  </li>
									  <li className={ "nav-item " + active[4].actif }>
										 <a style={{ cursor: 'pointer' }} className="nav-link" onClick={ e => handleClickGoto( 'contact' ) }>
											Contact
										 </a>
									  </li>
									</ul>
								</div>
							</nav>
						</div>
					</div>
					</div>
				</div>
			</header>
		</>
	);
};

export default Header;
